// 依頼参照用共通model
import { ReceptionTypeItem } from "./items";

export class ReceptionDispInfo {
  constructor() {
    this.commentLabelName = "コメント";
    this.nextMessageLabelName = "伝達事項";
    this.backMessageLabelName = "差戻しコメント";
    this.restrictCommentLabelName = "管理者コメント";
    this.contactedCommentLabelName = "連絡済情報";
    this.delCommentLabelName = "削除コメント";
    this.generalFlag1LabelName = "公開";
    this.isApplicantVisible = true;
    this.isRecipientVisible = true;
    this.isContactVisible = true;
    this.isProjectTeamVisible = true;
    this.isPaperNameVisible = false;
    this.isGeneralFlag1Visible = true;
    this.isInOutTypeVisible = false;
    this.isAddressTypeVisible = false;
  }

  // コメントラベル
  public commentLabelName: string;

  // 伝達事項ラベル
  public nextMessageLabelName: string;

  // 差戻しコメントラベル
  public backMessageLabelName: string;

  // 管理者コメントラベル
  public restrictCommentLabelName: string;

  // 連絡済コメントラベル
  public contactedCommentLabelName: string;

  // 削除コメントラベル
  public delCommentLabelName: string;

  // 汎用フラグ１ラベル
  public generalFlag1LabelName: string;

  // 申請者情報の表示有無
  public isApplicantVisible: boolean;

  // 受取者情報の表示有無
  public isRecipientVisible: boolean;

  // 連絡先情報の表示有無
  public isContactVisible: boolean;

  // プロジェクトチームの表示有無
  public isProjectTeamVisible: boolean;

  // 手書き文書名の表示有無
  public isPaperNameVisible: boolean;

  // 手書き会社名の表示有無
  public isPaperCompanyNameVisible: boolean;

  // 汎用フラグの表示有無
  public isGeneralFlag1Visible: boolean;

  // 入外区分の表示有無
  public isInOutTypeVisible: boolean;

  // 住所区分の表示有無
  public isAddressTypeVisible: boolean;

  public paymentStatusList: ReceptionTypeItem[];

  // 病名選択の表示有無
  public isDiseaseVisible: boolean;
}
